module.exports = __webpack_public_path__ + "static/media/money.d6ab8f52.svg";